module.exports = __webpack_public_path__ + "img/XHPsemi.f043fb1e.jpg";